import { render, staticRenderFns } from "./DisclaimerForm.vue?vue&type=template&id=027667cf&scoped=true&"
import script from "./DisclaimerForm.vue?vue&type=script&lang=ts&"
export * from "./DisclaimerForm.vue?vue&type=script&lang=ts&"
import style0 from "./DisclaimerForm.vue?vue&type=style&index=0&id=027667cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027667cf",
  null
  
)

export default component.exports